import React from 'react';
import StaticGameGrid from './components/StaticGameGrid';
import { GameAssetsProvider } from '../XXX/context/GameAssetContext';
import { ChampionConfig } from './types/staticTypes';

interface StaticSandboxAppProps {
  championName: string; // Required - no sandbox mode
  defaultOpponent?: string;
  defaultLane?: string;
  onExportToDamageCalculator?: (mainChampion: ChampionConfig, targetChampion: ChampionConfig) => void;
  onOpponentChange?: (opponent: string) => void;
}

const StaticSandboxApp: React.FC<StaticSandboxAppProps> = ({ championName, defaultOpponent, defaultLane, onExportToDamageCalculator, onOpponentChange }) => {

  const handleExportToDamageCalculator = (mainChampion: ChampionConfig, targetChampion: ChampionConfig) => {
    if (onExportToDamageCalculator) {
      // Use parent's handler if provided
      onExportToDamageCalculator(mainChampion, targetChampion);
    } else {
      // Default behavior - navigate to damage calculator with URL params
      const params = new URLSearchParams();
      params.set('mainChampion', JSON.stringify(mainChampion));
      params.set('targetChampion', JSON.stringify(targetChampion));
      
      const damageCalculatorUrl = `/damage-calculator?${params.toString()}`;
      window.open(damageCalculatorUrl, '_blank');
    }
  };

  return (
    <div className="static-sandbox-app">      
      <div className="static-sandbox-content">
        <GameAssetsProvider initialChampionName={championName}>
          <StaticGameGrid 
            championName={championName}
            defaultOpponent={defaultOpponent}
            defaultLane={defaultLane}
            onExportToDamageCalculator={handleExportToDamageCalculator}
            onOpponentChange={onOpponentChange}
          />
        </GameAssetsProvider>
      </div>
      
     
    </div>
  );
};

export default StaticSandboxApp; 